export default {
  v3SubmitErrBtnViewOrder: 'Bestellung anzeigen',
  v3SubmitErrBtnBackHome: 'Zur Startseite',
  v3SubmitErrBtnRetry: 'Wiederholen',
  v3SubmitErrBtnRelogin: 'Neu anmelden',
  v3SubmitErrBtnSwitchPay: 'Zahlungsart wechseln',
  v3SubmitErrBtnReorder: 'Neu bestellen',
  v3SubmitErrBtnSwitchServer: 'Server wechseln',
  v3SubmitErrBtnViewOrderStatus: 'Bestellstatus',
  v3SubmitErrBtnBackStore: 'Zurück zum Shop',
  v3SubmitErrBtnGoUpdate: 'Aktualisieren',
  v3SubmitErrBtnResubscribe: 'Erneut abonnieren',
  v3SubmitErrTipUpdateApp: 'Bitte im App Store aktualisieren',
  v3SubmitErrTipRelogin: 'Bitte neu anmelden',

  v3SubmitErrMsg120009: 'Bestellung bearbeitet – prüfe dein In-Game-Inventar.',
  v3SubmitErrMsg120003: 'Produktinformation fehlerhaft – bitte neu wählen.',
  v3SubmitErrMsg120016: 'Zu viele Anfragen – warte ein paar Sekunden und versuche es erneut.',
  v3SubmitErrMsg120025: 'Ungültige Anfrageparameter – bitte neu einloggen und erneut versuchen.',
  v3SubmitErrMsg121012: 'Zahlungskanal vorübergehend nicht verfügbar – bitte andere Methode versuchen.',
  v3SubmitErrMsg120012: 'Instabile Netzwerkverbindung – bitte Verbindung prüfen und erneut versuchen.',
  v3SubmitErrMsg120002: 'Kein Spielcharakter gefunden – bitte zuerst einen erstellen.',
  v3SubmitErrMsg121019: 'Bestellinformationen fehlerhaft – bitte neu bestellen.',
  v3SubmitErrMsg120024: 'Vorregistrierungsgeschenk bereits abgeholt – keine Wiederholung nötig.',
  v3SubmitErrMsg120000: 'Anmeldung abgelaufen – bitte neu einloggen.',
  v3SubmitErrMsg120014: 'Ungültige Bestellnummer – bitte neu bestellen.',
  v3SubmitErrMsg121001: 'Aufladung fehlgeschlagen – bitte später erneut versuchen oder Support kontaktieren.',
  v3SubmitErrMsg120015: 'Zahlungsbetrag fehlerhaft – bitte Produkt neu wählen.',
  v3SubmitErrMsg120001: 'Server stimmt nicht überein – bitte zum richtigen Server wechseln.',
  v3SubmitErrMsg120020: 'Zahlungskanal gab einen Fehler zurück – bitte andere Methode versuchen.',
  v3SubmitErrMsg120010: 'Aufladefunktion vorübergehend deaktiviert – bitte später versuchen.',
  v3SubmitErrMsg120006: 'Betragsprüfung fehlgeschlagen – bitte neu wählen.',
  v3SubmitErrMsg121010: 'Sandbox-Anfrage ungültig – bitte die offizielle Version verwenden.',
  v3SubmitErrMsg120017: 'Bestellnummer doppelt – bitte prüfen, ob bereits bezahlt wurde.',
  v3SubmitErrMsg120022: 'Zahlungs-Callback-Überprüfung fehlgeschlagen – bitte später erneut versuchen.',
  v3SubmitErrMsg121000: 'System ausgelastet – bitte später erneut versuchen.',
  v3SubmitErrMsg120011: 'Produkt-ID fehlerhaft – bitte neu wählen.',
  v3SubmitErrMsg121015: 'Überprüfung des Zahlungsbetrags fehlgeschlagen – bitte neu bestellen.',
  v3SubmitErrMsg120004: 'Dieser Zahlungskanal ist nicht geöffnet – bitte andere Methode wählen.',
  v3SubmitErrMsg120005: 'Zahlungskanal wird gewartet – bitte andere Methode verwenden.',
  v3SubmitErrMsg120007: 'Ungültige Plattform-ID – bitte neu einloggen.',
  v3SubmitErrMsg120008: 'Unzureichende Anfrageparameter – bitte erneut senden.',
  v3SubmitErrMsg120013: 'Falsche Bestellnummer des Entwicklers – bitte neu bestellen.',
  v3SubmitErrMsg120018: 'Zahlung durch Risikokontrolle blockiert – bitte Support zur Prüfung kontaktieren.',
  v3SubmitErrMsg120019: 'Paketnamenprüfung fehlgeschlagen – bitte offizielle Version verwenden.',
  v3SubmitErrMsg120021: 'Produkt-ID-Überprüfung fehlgeschlagen – bitte neu wählen.',
  v3SubmitErrMsg120023: 'Fehler bei der Vergabe des Vorregistrierungsgeschenks – bitte später prüfen.',
  v3SubmitErrMsg120026: 'Konto nicht gefunden – bitte Kontostatus prüfen.',
  v3SubmitErrMsg120030: 'Gesamtbestand nicht ausreichend – bitte anderen Artikel wählen.',
  v3SubmitErrMsg120031: 'Du hast das Kauflimit für diesen Artikel überschritten – bitte anpassen.',
  v3SubmitErrMsg120032: 'Spielversion zu alt – bitte neueste Version herunterladen.',
  v3SubmitErrMsg120080: 'Agentenzahlung durch Risikokontrolle eingeschränkt – bitte eigene Zahlungsmethode verwenden.',
  v3SubmitErrMsg120081: 'Agentenzahlung durch Risikokontrolle verzögert – bitte später Ergebnis prüfen.',
  v3SubmitErrMsg121002: 'Auftragscache ungültig – bitte neu bestellen.',
  v3SubmitErrMsg121003: 'Aufladekonfiguration nicht gefunden – bitte Support kontaktieren.',
  v3SubmitErrMsg121004: 'Unzureichende erweiterte Parameter – bitte erneut senden.',
  v3SubmitErrMsg121005: 'Cache-Schreiben fehlgeschlagen – bitte später erneut versuchen.',
  v3SubmitErrMsg121006: 'Cache-Lesen fehlgeschlagen – bitte später erneut versuchen.',
  v3SubmitErrMsg121007: 'Fehler in der Aufladetyp-Konfiguration – bitte Support kontaktieren.',
  v3SubmitErrMsg121011: 'Neue Felder von Apple erkannt – bitte App aktualisieren.',
  v3SubmitErrMsg121013: 'Verlängerungsbestellung nicht gefunden – bitte erneut abonnieren.',
  v3SubmitErrMsg121014: 'Entschlüsselung der Aufladeparameter fehlgeschlagen – bitte erneut senden.',
  v3SubmitErrMsg121017: 'Diese Bestellung wurde erstattet – bitte Support zur Bestätigung kontaktieren.',
  v3SubmitErrMsg121018: 'Abonnement abgelaufen – bitte neu abonnieren.',
  v3SubmitErrMsg121020: 'Bestellung storniert – bitte neu bestellen.',
  v3SubmitErrMsg121021: 'Google-API-Fehler – bitte später erneut versuchen.',
  v3SubmitErrMsg121022: 'Abruf des Zugriffstokens fehlgeschlagen – bitte neu einloggen.',
  v3SubmitErrMsg121023: 'Bestellstatus ungewöhnlich – bitte Eingangsstatus prüfen.',
  v3SubmitErrMsg121024: 'Bestellbestätigung fehlgeschlagen – bitte später erneut versuchen.'
};
